
/* Domus Giulietta · Tarefa 26 · formulário da Consulta Privada (blocks/dg-form-contato.liquid).
   Liquid não lê a query string (E-D8): este script preenche o Assunto (?assunto=) e a Peça de
   interesse (?peca=<handle>, trocado pelo título da peça), troca o rótulo do botão no envio e leva
   o foco ao aviso de sucesso ou de erro. Ouvintes delegados: o editor re-renderiza o bloco.
   Correção 01 do controlador: o rótulo original fica guardado em data-dg-rotulo, um segundo envio
   é ignorado enquanto o botão estiver aria-busy, e a volta pelo histórico (pageshow com
   event.persisted) devolve o rótulo — antes o botão ficava travado em "Enviando…". */
(function () {
  if (window.dgContato) return;

  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  function raiz() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  function preencher(bloco) {
    if (!bloco || bloco.dataset.dgContatoPronto) return;
    bloco.dataset.dgContatoPronto = '1';
    var params = new URLSearchParams(window.location.search);

    var assunto = (params.get('assunto') || '').toLowerCase();
    var lista = bloco.querySelector('[data-dg-contato-assunto]');
    if (assunto && lista) {
      Array.prototype.forEach.call(lista.options, function (opcao) {
        if (opcao.getAttribute('data-assunto') === assunto) lista.value = opcao.value;
      });
    }

    var handle = (params.get('peca') || '').toLowerCase();
    var oculto = bloco.querySelector('[data-dg-contato-peca]');
    if (oculto && HANDLE.test(handle)) {
      oculto.value = handle;
      fetch(raiz() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p && p.title) oculto.value = p.title; })
        .catch(function () { /* fica o handle: o envio nunca quebra */ });
    }

    var aviso = bloco.querySelector('[data-dg-contato-foco]');
    if (aviso) aviso.focus();
  }

  function iniciar() {
    document.querySelectorAll('[data-dg-contato]').forEach(preencher);
  }

  function rotular(form, ocupado) {
    var botao = form.querySelector('button[type="submit"]');
    var modelo = form.querySelector('[data-dg-contato-enviando]');
    if (!botao) return;
    var rotulo = botao.querySelector('span') || botao;
    if (ocupado) {
      if (!modelo) return;
      if (!botao.hasAttribute('data-dg-rotulo')) botao.setAttribute('data-dg-rotulo', rotulo.textContent);
      rotulo.textContent = modelo.innerHTML.trim();
      botao.setAttribute('aria-busy', 'true');
      return;
    }
    if (botao.hasAttribute('data-dg-rotulo')) {
      rotulo.textContent = botao.getAttribute('data-dg-rotulo');
      botao.removeAttribute('data-dg-rotulo');
    }
    botao.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    var bloco = form && form.closest ? form.closest('[data-dg-contato]') : null;
    if (!bloco) return;
    var botao = form.querySelector('button[type="submit"]');
    if (botao && botao.getAttribute('aria-busy') === 'true') {
      evento.preventDefault();
      return;
    }
    rotular(form, true);
  });

  window.addEventListener('pageshow', function (evento) {
    if (!evento.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-dg-contato] form'), function (form) {
      rotular(form, false);
    });
  });

  document.addEventListener('shopify:section:load', iniciar);
  document.addEventListener('shopify:block:select', iniciar);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  window.dgContato = { iniciar: iniciar, HANDLE: HANDLE };
})();
